import React, { useState } from 'react';

import {  Card, Input } from 'antd';
import { BookOutlined, EditOutlined, FileTextOutlined, FontSizeOutlined } from '@ant-design/icons';

import { useFetchPageData, usePageData } from '../../hooks/usePage';

import { IPageData } from '../../interfaces/page';
import { IOption } from '../../interfaces/option';

type Limit = [number, number, number];

const pageData: IPageData = {
  title: 'Autocompletes',
  breadcrumbs: [
    {
      title: 'UI Kit',
      route: 'default-dashboard'
    },
    {
      title: 'Components',
      route: 'default-dashboard'
    },
    {
      title: 'Autocompletes'
    }
  ]
};

const AutocompletePage = () => {
  const [dataSource] = useFetchPageData<IOption[]>('./data/autocomplete.json', []);
  usePageData(pageData);

  const [limits, setLimits] = useState<Limit>([0, 0, 0]);
  const [first, second, third] = limits;

  function setFirst(newLimit) {
    setLimits([newLimit, second, third]);
  }

  function setSecond(newLimit) {
    setLimits([first, newLimit, third]);
  }

  function setThird(newLimit) {
    setLimits([first, second, newLimit]);
  }

  const handleChange = (maxCount: number, setter) => (value: string) => {
    setter(maxCount - value.length);
  };

  return (
    <div className='row'>
      <div className='col-md-6 col-sm-12'>
        <Card title='Basic'>
          <div className='elem-list'>

          </div>
        </Card>

        <Card title='Input sizes' className='mb-md-0'>
          <div className='elem-list'>

          </div>
        </Card>
      </div>

      <div className='col-md-6 col-sm-12'>
        <Card title='With icons'>
          <div className='elem-list'>

          </div>
        </Card>

        <Card title='Char limiting' className='mb-0'>
          <div className='elem-list'>

          </div>
        </Card>
      </div>
    </div>
  );
};

export default AutocompletePage;
